import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { defaultEnvironmentConfig, EnvironmentConfig, EnvironmentConfigService } from '@stylehaven/components';

@Injectable({
    providedIn: 'root'
})
export class MediahavenConfigService extends EnvironmentConfigService {
    protected readonly FALLBACK_VALUE: EnvironmentConfig = defaultEnvironmentConfig;
    protected readonly TYPE_NAME: string = 'MediaHavenConfig';

    constructor(protected http: HttpClient) {
        super(http);
    }

    protected override checkRequiresEnrichment(config: EnvironmentConfig): boolean {
        return true;
    }

    protected override createConfigEnrichment(config: EnvironmentConfig): Partial<EnvironmentConfig> {
        const baseUrl: string = window.location.host;

        return {
            baseUrl: config.baseUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            apiUrl: config.apiUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            authenticationUrl: config.authenticationUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            authorizationUrl: config.authorizationUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            managementAppUrl: config.managementAppUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            extendedMediaPlayerUrl: config.extendedMediaPlayerUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            monitoringUrl: config.monitoringUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            importUrl: config.importUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            embedUrl: config.embedUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            permalinkBase: config.permalinkBase.replace(this.HOST_PLACEHOLDER, baseUrl)
        };
    }
}
